<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0935 6H6.36458C5.52344 6 5 6.60156 5 7.46875V15.5078C5 16.375 5.5007 17 6.36458 17H12.0935C12.5936 17 13 17.4844 13 18C13 18.5156 12.5936 19 12.0935 19H6.36458C4.52315 19 3 17.4297 3 15.5078V7.46875C3 5.57031 4.52315 4 6.36458 4H12.0935C12.5936 4 13.0028 4.48438 13.0028 5C13.0028 5.51562 12.5936 6 12.0935 6Z"
      fill="#636363"
    />
    <path
      d="M20.7282 10.8333C20.9094 11 21 11.2381 21 11.5C21 11.7619 20.9094 12 20.7282 12.1905L17.3763 15.7143C17.1951 15.9048 16.9686 16 16.7422 16C16.5157 16 16.2892 15.9048 16.108 15.7143C15.7456 15.3333 15.7456 14.7381 16.108 14.3571L17.9199 12.4524H8.90592C8.40767 12.4524 8 12.0238 8 11.5C8 10.9762 8.40767 10.5476 8.90592 10.5476H17.8972L16.0854 8.64286C15.723 8.2619 15.723 7.66667 16.0854 7.28571C16.4477 6.90476 17.0139 6.90476 17.3763 7.28571L20.7282 10.8333Z"
      fill="#636363"
    />
  </svg>
</template>
